import { useCallback } from 'react';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import type { Market } from '@//config/domain-locale-map';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import { useMarket } from '@//providers/MarketSettingsProvider';
import type { LegacyTrackPhoneNumberCallEventData } from './legacy-types';
import { mapElasticVehicleToLegacyItem } from './utils';

export const createLegacyTrackPhoneNumberCall = (
  market: Market,
  vehicle: ElasticVehicle,
): LegacyTrackPhoneNumberCallEventData => {
  const eventData: LegacyTrackPhoneNumberCallEventData = {
    eventType: 'other',
    conversionType: 'phonenumber-call',
    item: mapElasticVehicleToLegacyItem(market, vehicle),
    pageType: 'product page',
  };

  return eventData;
};

export const useLegacyTrackPhoneNumberCall = () => {
  const market = useMarket();
  const { track } = useLegacyTracking();

  const trackLegacyPhoneNumberCall = useCallback(
    (vehicle: ElasticVehicle) => {
      // Track event with only the event-specific data
      // The provider will inject base data (source, url, eventTimestamp, userData)
      track({
        event: 'other',
        data: createLegacyTrackPhoneNumberCall(market, vehicle),
      });
    },
    [market, track],
  );

  return {
    trackLegacyPhoneNumberCall,
  };
};
